import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.6.0_@parcel+watcher@2.4.1_@types+node@20.14.6_@upstash+redis@1.31.5_@vercel+kv@0.2.2_e_lqwcikvcsgst6mpypiyywnvhue/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}